import './assets/css/App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RequireProfile from './components/RequireProfile';
import { AuthProvider } from 'views/admin/auth/AuthProvider';
import RTLLayout from './layouts/rtl';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import pgTheme from './theme/themePG';
import { useState } from 'react';
// Chakra imports

export default function Main() {
  const [currentTheme, setCurrentTheme] = useState(pgTheme); 
  return (
    <ChakraProvider theme={currentTheme}>
      <Routes>
        <Route path="auth/*" element={<AuthLayout />} />
        <Route
          path="admin/*"
          element={
            <AuthProvider>
              <RequireProfile>
                <AdminLayout theme={currentTheme} setTheme={setCurrentTheme} />
              </RequireProfile>
            </AuthProvider>
          }
        />
            <Route path="/admin/dashboards" element={<Navigate to="/admin" replace />} />
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </ChakraProvider>
  );
}
